<template>
  <div class="privacy mk-container">
    <Breadcrumbs />
    <div class="privacy-container">
      <div class="muzik-markdown" v-html="compiledText">
        <!-- -->
      </div>
      <Paganiniplus />
    </div>
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
export default {
  name: 'Privacy',
  components: {
    Paganiniplus,
    Breadcrumbs
  },
  props: {},
  data() {
    return {
      compiledText: ''
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      // const productionName = this.$production.toUpperCase()ww
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('PRIVACY.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.$t('PRIVACY.TITLE')
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    keywords() {
      return this.$t('PRIVACY.TITLE')
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`
    },
    structuredData() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const urlSubDomain = isAirProduction ? '' : `${process.env[subDomainKey]}.`
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.title,
        relatedLink: [
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      }
      return structuredData
    },
    locale() {
      // watch $i18n locale
      return this.$i18n.locale
    },
    getLocaleText() {
      return require('@/i18n/announcement/privacy/' + this.locale + '.js')
    }
  },
  watch: {
    locale(newValue) {
      this.renderLocaleText()
    }
  },
  created() {},
  async mounted() {
    await this.dynamicLoadScript()
    /* eslint-disable no-undef */
    window.marked = marked
    this.renderLocaleText()
  },
  methods: {
    async renderLocaleText() {
      if (window.marked) {
        this.compiledText = marked(this.getLocaleText, { sanitize: true })
      }
    },
    async dynamicLoadScript() {
      return new Promise((resolve, reject) => {
        let markedJS = document.createElement('script')
        // markedJS.setAttribute('type', 'text/javascript')
        // markedJS.setAttribute('src', 'https://cdn.jsdelivr.net/npm/marked/marked.min.js')
        markedJS.async = true
        markedJS.type = 'text/javascript'
        markedJS.src = 'https://cdn.jsdelivr.net/npm/marked/marked.min.js'
        document.head.appendChild(markedJS)
        markedJS.onload = () => {
          resolve()
        }
        markedJS.onerror = err => {
          reject(err)
        }
      })
    }
  }
}
</script>
<style lang="scss">
// No scoped for markdown diaplay
@import '@/assets/scss/variables.scss';

.privacy {
  font-size: 16px;
  color: $grey-7d;
  &-container {
    margin: 24px 0;
  }
}

@media only screen and (min-width: 1440px) {
  .privacy {
    &-container {
      max-width: 1024px;
      margin: 36px auto;
    }
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .privacy {
    &-container {
      margin-top: 24px;
      margin-bottom: 24px;
      margin-left: $padding-md-grid-x1;
      margin-right: $padding-md-grid-x1;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
